import { createStore, withProps } from '@ngneat/elf';
import { Paa, PaaDto } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface PaaStateProps {
  response: Paa;
  dto?: Partial<PaaDto>;
  initialDto?: Partial<PaaDto>;
  totalEstimatedBudget: number;
  acsSelected?: SelectOption;
  //dowbload
  download: {
    signPerson: string;
    function: string;
  };
  upload: {
    modelPpmFile: File[];
  };
}

export const paaInitialDto: PaaDto = {
  nom: '',
  acId: undefined,
  annee: undefined,
  paaFiles: [],
  docIds: [],
  remarque: '',
};

export const paaInitialState: PaaStateProps = {
  response: {
    id: 0,
    version: 0,
    ref: '',
    nom: '',
    annee: '',
    ac: { id: 0, nom: '', ancrage: '', contact: '', coms: [] },
    budgetEstime: undefined,
    status: '',
    realisations: [],
    docs: [],
    processInstanceId: null,
    remarque: '',
    actualise: false,
    nbrActualisation: 0,
  },
  dto: structuredClone(paaInitialDto),
  initialDto: structuredClone(paaInitialDto),
  totalEstimatedBudget: 0,
  acsSelected: { name: '', code: 0 },
  download: {
    signPerson: '',
    function: '',
  },
  upload: {
    modelPpmFile: [],
  },
};

export const paaStateStore = createStore(
  { name: 'paa-state' },
  withProps<PaaStateProps>({
    ...paaInitialState,
  })
);
